import { render } from "./indexInternationalization.vue?vue&type=template&id=3c8c3b25"
import script from "./indexInternationalization.vue?vue&type=script&lang=js"
export * from "./indexInternationalization.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__